var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPharmacyTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.505,
    height: 25.5,
    viewBox: "0 0 25.505 25.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-1183481",
    d: "M104.567,111.339H98.448a.246.246,0,0,1-.247-.246v-6.052l-5.264,3.026a.247.247,0,0,1-.337-.09L89.54,102.7a.245.245,0,0,1,.09-.336l5.264-3.026-5.264-3.026a.245.245,0,0,1-.09-.336L92.6,90.7a.248.248,0,0,1,.337-.09L98.2,93.636V87.585a.246.246,0,0,1,.247-.246h6.119a.246.246,0,0,1,.247.246v6.052l5.264-3.026a.248.248,0,0,1,.337.09l3.06,5.276a.245.245,0,0,1-.09.336l-5.264,3.026,5.264,3.026a.245.245,0,0,1,.09.336l-3.059,5.276a.247.247,0,0,1-.337.09l-5.264-3.026v6.053a.246.246,0,0,1-.247.246Zm-5.872-.492h5.625v-6.232a.247.247,0,0,1,.37-.213l5.421,3.116,2.813-4.851-5.42-3.116a.245.245,0,0,1,0-.426l5.42-3.116-2.813-4.85-5.421,3.116a.248.248,0,0,1-.247,0,.245.245,0,0,1-.124-.213V87.83H98.694v6.232a.247.247,0,0,1-.37.213L92.9,91.159l-2.813,4.851,5.42,3.116a.245.245,0,0,1,0,.426l-5.42,3.116,2.813,4.851,5.42-3.116a.248.248,0,0,1,.247,0,.245.245,0,0,1,.124.213v6.232Z",
    transform: "translate(-88.755 -86.589)",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacyTransparent);
export default __webpack_public_path__ + "static/media/pharmacy-transparent.c864840ac5aefb96b277d3ef8c4d5deb.svg";
export { ForwardRef as ReactComponent };